import React, { useState } from 'react';
import { marked } from 'marked';

/**
 * Collapsible "Process details" card. Shown in place of every
 * `<internal>...</internal>` block the agent emits. The content
 * inside is rendered as markdown but muted, so the user can expand
 * it when curious without it taking visual weight in chat.
 *
 * Ported from PitchPilot main (PR #105) — keeps the same shape so
 * users see identical UI on both products.
 */
export default function ChatInternalBlock({ text }: { text: string }) {
  const [open, setOpen] = useState(false);
  const html = marked.parse(text || '') as string;

  return (
    <div
      className="pp-internal-block"
      data-state={open ? 'open' : 'closed'}
      style={{ margin: '6px 0' }}
    >
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className="pp-internal-toggle"
        style={{
          appearance: 'none',
          background: 'transparent',
          border: '1px solid var(--border)',
          borderRadius: 999,
          padding: '2px 10px',
          fontSize: 'var(--fs-xs)',
          color: 'var(--text-muted)',
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          lineHeight: 1.4,
        }}
      >
        <span
          aria-hidden="true"
          style={{
            display: 'inline-block',
            transition: 'transform 0.15s ease',
            transform: open ? 'rotate(90deg)' : 'rotate(0deg)',
          }}
        >
          ▸
        </span>
        Process details
      </button>
      {open && (
        <div
          className="chat-md pp-internal-body"
          style={{
            marginTop: 6,
            padding: '8px 12px',
            borderLeft: '2px solid var(--border)',
            color: 'var(--text-secondary)',
            fontSize: 'var(--fs-sm)',
            lineHeight: 1.6,
          }}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      )}
    </div>
  );
}
